"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class DcCreateAccount extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'dcCreateAccount';
        this._emailAddress = initParams.email_address;
        this._password = initParams.password;
    }
    set emailAddress(value) {
        console.error('Do not set objects this way');
    }
    get emailAddress() {
        return this._emailAddress;
    }
    set password(value) {
        console.error('Do not set objects this way');
    }
    get password() {
        return this._password;
    }
}
exports.default = DcCreateAccount;
//# sourceMappingURL=dcCreateAccount.js.map